angular.module('smartorg.r6.navs.workspace').directive("workspace", ["$timeout", "terminologyService", function ($timeout, terminologyService) {
        return {
            restrict: 'E',
            template: require('../../template/workspace.html'),
            transclude: true,
            scope: {
                smartorg: '=?',
                selected: '=?',
                username: '@?',
                isInav: '=?',
                isCorteva: '=?',
                terminology: '=?',
                showAbilityToLaunchColumn: '=?'
            },
            link: function (scope) {
                // Initialize terminology if not provided
                if (!scope.terminology) {
                    scope.terminology = terminologyService.getDefaultTerminology();
                }
                // Listen for terminology requests from child components
                scope.$on('terminology:request', function (event) {
                    if (scope.terminology) {
                        event.targetScope.$emit('terminology:response', scope.terminology);
                    }
                });
                scope.menuBox = {
                    menu: {}
                };
                scope.$on('workspace:reloadAction', function (event, args) {
                    if ('chartSettings' in scope.newConfig) {
                        scope.newConfig['chartSettings'] = args.portfolioConfig['chart'];
                        scope.newConfig['settings'] = args.portfolioConfig['table'];
                    }
                    else {
                        scope.newConfig['settings'] = args.portfolioConfig['chart'];
                    }
                    scope.$broadcast("command:" + scope.command, scope.newConfig);
                });
                scope.$on('workspace:action', function (event, args) {
                    scope.command = args.command.trim();
                    $timeout(function () {
                        scope.$apply();
                        scope.newConfig = args.config;
                        scope.newConfig['username'] = scope.username;
                        // Include terminology in the config
                        scope.newConfig['terminology'] = scope.terminology;
                        // Include showAbilityToLaunchColumn in the config
                        scope.newConfig['showAbilityToLaunchColumn'] = scope.showAbilityToLaunchColumn;
                        scope.$broadcast("command:" + scope.command, scope.newConfig);
                    }, 200);
                });
            }
        };
    }]);
//# sourceMappingURL=workspace-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/workspace/app/js/plumbing/workspace-directive.js